import React from "react";
import { Route, Routes } from "react-router-dom";
import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";
import Header from "@components/Header";
import { Column } from "@components/Flex";
import { useStores } from "@stores";
import WalletModal from "@components/Wallet/WalletModal";
import SettingsSidebar from "@components/SettingsSidebar";
import { OPERATIONS_TYPE, ROME_OPERATION_TYPES, ROUTES } from "@src/constants";
import DashboardHome from "@screens/DashboardHome/DashboardHome";
import ExploreToken from "@screens/ExploreToken";
import NotFound from "@screens/NotFound";
import LoginScreen from "./screens/LoginScreen";
import MarketPage from "@screens/MarketPage";
import MarketModal from "@screens/MarketPage/MarketModals/MarketModals";
import RomeMarketModal from "@screens/MarketPage/RomeMarket/RomeMarketModals/RomeMarketModals";
import RomeMarket from "@screens/MarketPage/RomeMarket/RomeMarket";
import TermsOfService from "@screens/TermsOfService/TermsOfService";
import Confetti from "react-confetti";
import { ReactNotifications } from 'react-notifications-component';

const Root = styled(Column)`
  width: 100%;
  align-items: center;
  background: ${({ theme }) => theme.colors.primary50};
  min-height: 100vh;
`;


const App: React.FC = () => {
  const { accountStore } = useStores();
  return (
    <Root>
      <ReactNotifications />
      {accountStore.confettiOpen && (
        <Confetti
          drawShape={(ctx) => {
            ctx.font = "20px serif";
            ctx.fillText("💵", 0, 0);
          }}
        />
      )}
      <LoginScreen />
      <Header />
      <Routes>
        <Route path={ROUTES.DASHBOARD} element={<DashboardHome />} />

        <Route path={ROUTES.MARKET_ROME} element={<RomeMarket />}>
          {[...Object.entries(ROUTES.MARKET_ROME_MODALS)].map(
            ([type, path]) => (
              <Route
                path={path}
                key={path}
                element={
                  <RomeMarketModal
                    operationName={type as ROME_OPERATION_TYPES}
                  />
                }
              />
            )
          )}
        </Route>

        <Route path={ROUTES.MARKET} element={<MarketPage />}>
          {[...Object.entries(ROUTES.MARKET_MODALS)].map(([type, path]) => (
            <Route
              path={path}
              key={path}
              element={<MarketModal operationName={type as OPERATIONS_TYPE} />}
            />
          ))}
        </Route>

        <Route path={ROUTES.MARKET_TOKEN_DETAILS} element={<ExploreToken />} />
        <Route path={ROUTES.TERMS_OF_SERVICE} element={<TermsOfService />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <WalletModal
        onClose={() => accountStore.setWalletModalOpened(false)}
        visible={accountStore.walletModalOpened}
      />
      <SettingsSidebar
        visible={accountStore.settingsSidebarOpened}
        onClose={() => accountStore.setSettingsSidebarOpened(false)}
      />
    </Root>
  );
};

export default observer(App);
